import React, { Fragment } from 'react'
import { dashboardURL } from '../../utils/constants'

const DefaultPage = () => {
  const redirectToHomePage = () => {
    window.location.href = dashboardURL
  }
  return <Fragment>{redirectToHomePage()}</Fragment>
}

export default DefaultPage
